import SCHOOL_LOGO_IMAGE from "../assets/images/school-logo.png";
const SCHOOL_NAME = "School of Eminence";

const SCHOOL_LOCATION = "Sahnewal";
const SCHOOL_DISTRICT = "Ludhiana";
const SCHOOL_SUPPORT_NUMBER = "+91 85478569852";
const SCHOOL_SUPPORT_EMAIL = "school@gmail.com";
const SCHOOL_FACILITIES = [
    {
    id: 1,
    title: "Library",
    slug: "library",
    images: [
      "https://springdalesdubai.com/wp-content/uploads/2024/05/1.png",
      "https://media.istockphoto.com/id/1351416161/photo/female-teachers-teaching-students-in-library-at-school.jpg?s=1024x1024&w=is&k=20&c=66NH30EsyJFQrt10Yx640cYwaDRwNXO80FuQQzmhFSw=",
      "https://media.istockphoto.com/id/1055899912/photo/young-group-of-students-in-a-robotics-club-having-fun.jpg?s=1024x1024&w=is&k=20&c=W_V1leRhcnNkJW8a67z0mRsLvKDnbJHmWvtLvMdXsb0=",
      "https://springdalesdubai.com/wp-content/uploads/2024/05/1.png",
      "https://springdalesdubai.com/wp-content/uploads/2024/05/1.png",
       "https://media.istockphoto.com/id/1351416161/photo/female-teachers-teaching-students-in-library-at-school.jpg?s=1024x1024&w=is&k=20&c=66NH30EsyJFQrt10Yx640cYwaDRwNXO80FuQQzmhFSw=",
      "https://media.istockphoto.com/id/1055899912/photo/young-group-of-students-in-a-robotics-club-having-fun.jpg?s=1024x1024&w=is&k=20&c=W_V1leRhcnNkJW8a67z0mRsLvKDnbJHmWvtLvMdXsb0=",
      
    ],
    descriptions: [
      "Our library is a vast resource hub with thousands of books.",
      "It includes digital access to academic journals and eBooks.",
      "Students can engage in quiet reading zones and group study areas."
    ]
  },
  {
    id: 2,
    title: "Canteen",
    slug: "canteen",
    images: [
      "https://www.springdalesdubai.com/wp-content/uploads/2020/05/facilities4.jpg",
      "https://media.istockphoto.com/id/1351416161/photo/female-teachers-teaching-students-in-library-at-school.jpg?s=1024x1024&w=is&k=20&c=66NH30EsyJFQrt10Yx640cYwaDRwNXO80FuQQzmhFSw=",
      "https://example.com/canteen3.jpg"
    ],
    descriptions: [
      "Our canteen serves nutritious meals throughout the day.",
      "Special meals are available for students with dietary needs.",
      "It maintains high hygiene standards approved by health authorities."
    ]
  },
  {
    id: 3,
    title: "Playground",
    slug: "playground",
    images: [
      "https://www.springdalesdubai.com/wp-content/uploads/2020/05/facilities3.jpg",
      "https://example.com/playground2.jpg",
      "https://example.com/playground3.jpg"
    ],
    descriptions: [
      "The playground includes football fields and basketball courts.",
      "Safe play areas are designated for younger students.",
      "Supervision ensures children's safety during recess."
    ]
  },
  {
    id: 4,
    title: "Chemistry Laboratory",
    slug: "chemistry-lab",
    images: [
      "https://www.springdalesdubai.com/wp-content/uploads/2020/05/facilities5.jpg",
      "https://example.com/lab2.jpg",
      "https://example.com/lab3.jpg"
    ],
    descriptions: [
      "Our Chemistry lab is equipped with modern instruments.",
      "Students conduct experiments under expert supervision.",
      "The lab encourages scientific exploration and learning."
    ]
  }
];

export const STUDENT_TOPPERS = [
  {
    id: 1,
    name: "Aarav Mehta",
    class: "10th",
    percentage: "96.4%",
    image: "https://images.pexels.com/photos/4145192/pexels-photo-4145192.jpeg",
  },
  {
    id: 2,
    name: "Diya Sharma",
    class: "12th",
    percentage: "94.8%",
    image: "https://images.pexels.com/photos/733872/pexels-photo-733872.jpeg",
  },
  // add more...
];


const ROUTES_CONFIG = {
    HOMEPAGE: {
        path: "/",
        title: "Home",
    },
    ABOUT_US: {
        title: "About",
        path: "#about",
    },
    FACILITIES: {
        path: "/facilities",
        title: "Our Facilites",
    },
    FACILITIES_DETAIL: {
        path: "/facilities/:slug",
        title: "Our Facility",
    },
    FACILITIES_FULL_DETAIL: {
        path: "/facilities/:slug/detail",
        title: "Our Facility",
    },
    DIRECTORS_MESSAGE: {
        path: "/director-message",
        title: "Director's message",
    },
    CONTACT_US: {
        path: "/contact-us",
        title: "Contact Us",
    },
    LOGIN: {
        path: "/login",
        title: "Login",
    },
    DASHBOARD: {
        path: "/dashboard",
        title: "Dashboard",
    },
    FACULTY: {
        path: "/faculty",
        title: "Faculty",
    },
    ACADEMICS: {
        title: "Academics",
        path: "#academics",
    },
    SYLLABUS: {
        title: "Syllabus",
        path: "/syllabus",
    },
};

export {
    SCHOOL_NAME,
    SCHOOL_LOCATION,
    SCHOOL_DISTRICT,
    SCHOOL_SUPPORT_NUMBER,
    SCHOOL_SUPPORT_EMAIL,
    SCHOOL_LOGO_IMAGE,
    SCHOOL_FACILITIES,
    ROUTES_CONFIG,
};
